<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.addMarketingCampaign") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.campaignName')"
            v-model.trim="data.campaign_name"
            :errors="fieldErrors.campaign_name"
            required
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.targetUrl')"
            v-model.trim="data.target_url"
            :errors="fieldErrors.target_url"
            required
          />

          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.startDate')"
            v-model.trim="data.start_date"
            :errors="fieldErrors.start_date"
          />

          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.endDate')"
            v-model.trim="data.end_date"
            :errors="fieldErrors.end_date"
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.utmSource')"
            v-model.trim="data.utm_source"
            :errors="fieldErrors.utm_source"
            required
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.utmMedium')"
            v-model.trim="data.utm_medium"
            :errors="fieldErrors.utm_medium"
            required
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.utmCampaign')"
            v-model.trim="data.utm_campaign"
            :errors="fieldErrors.utm_campaign"
            required
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateMarketingCampaign",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        campaign_name: null,
        start_date: null,
        end_date: null,
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        target_url: null,
      },
      fieldErrors: {},
    };
  },

  methods: {
    clearFieldErrors() {
      this.fieldErrors = {};
    },

    validateClientSide() {
      this.clearFieldErrors();
      let isValid = true;

      if (!this.data.campaign_name) {
        this.fieldErrors.campaign_name = this.$t("VALIDATION.campaignName");
        isValid = false;
      }

      if (!this.data.start_date) {
        this.fieldErrors.start_date = this.$t("VALIDATION.startDate");
        isValid = false;
      }

      if (!this.data.end_date) {
        this.fieldErrors.end_date = this.$t("VALIDATION.endDate");
        isValid = false;
      }

      if (
        this.data.start_date &&
        this.data.end_date &&
        this.data.end_date <= this.data.start_date
      ) {
        this.fieldErrors.end_date = this.$t("VALIDATION.endDateAfterStart");
        isValid = false;
      }

      if (!this.data.utm_source) {
        this.fieldErrors.utm_source = this.$t("VALIDATION.utmSource");
        isValid = false;
      }

      if (!this.data.utm_medium) {
        this.fieldErrors.utm_medium = this.$t("VALIDATION.utmMedium");
        isValid = false;
      }

      if (!this.data.utm_campaign) {
        this.fieldErrors.utm_campaign = this.$t("VALIDATION.utmCampaign");
        isValid = false;
      } else if (!/^[a-z0-9-]+$/.test(this.data.utm_campaign)) {
        this.fieldErrors.utm_campaign = this.$t("VALIDATION.utmCampaignFormat");
        isValid = false;
      }

      if (!this.data.target_url) {
        this.fieldErrors.target_url = this.$t("VALIDATION.targetUrl");
        isValid = false;
      } else if (!/^https?:\/\/.+/i.test(this.data.target_url)) {
        this.fieldErrors.target_url = this.$t("VALIDATION.targetUrlFormat");
        isValid = false;
      }

      return isValid;
    },

    validateFormInputs() {
      if (!this.validateClientSide()) {
        return;
      }

      this.isWaitingRequest = true;
      this.submitForm();
    },

    handleValidationErrors(error) {
      const errors = error?.response?.data?.errors;
      if (!errors) {
        this.$message.error(
          error?.response?.data?.message || this.$t("MESSAGES.somethingWentWrong")
        );
        return;
      }

      Object.keys(errors).forEach((field) => {
        this.fieldErrors[field] = errors[field][0];
      });
      this.$message.error(error.response.data.message);
    },

    async submitForm() {
      try {
        await this.$axios({
          method: "POST",
          url: "marketing-campaigns",
          data: {
            campaign_name: this.data.campaign_name,
            start_date: this.data.start_date,
            end_date: this.data.end_date,
            utm_source: this.data.utm_source,
            utm_medium: this.data.utm_medium,
            utm_campaign: this.data.utm_campaign,
            target_url: this.data.target_url,
          },
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/marketing-campaigns/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        if (error?.response?.status === 422) {
          this.handleValidationErrors(error);
        } else {
          this.$message.error(
            error?.response?.data?.message ||
              this.$t("MESSAGES.somethingWentWrong")
          );
        }
      }
    },
  },
};
</script>
